var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavouriteOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.151,
    height: 31.591,
    viewBox: "0 0 34.151 31.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-favorite-border",
    "data-name": "Icon material-favorite-border",
    d: "M27.035,4.5a9.926,9.926,0,0,0-7.459,3.464A9.926,9.926,0,0,0,12.117,4.5,9.028,9.028,0,0,0,3,13.617c0,6.266,5.636,11.371,14.172,19.128l2.4,2.171,2.4-2.188c8.536-7.741,14.172-12.846,14.172-19.112A9.028,9.028,0,0,0,27.035,4.5Z",
    transform: "translate(-2.5 -4)",
    fill: "rgba(255,255,255,0)",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavouriteOutline);
export default __webpack_public_path__ + "static/media/favourite-outline.8956e867d44e8f9952d1955878e04c0e.svg";
export { ForwardRef as ReactComponent };